// extracted by mini-css-extract-plugin
module.exports = {"root":"ImgPreview_root__2O3AV","skeleton":"ImgPreview_skeleton__1CRQI","loading":"ImgPreview_loading__qjarV","img":"ImgPreview_img__2rhVj"};